import React from "react";
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from "../../../common";

let { WizPopover, WizButton } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })


export default (self, type, info) => {
  let columns = []
  columns = columns.concat([
    {
      title: '账号',
      name: 'userName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '任职',
      name: 'userIdentityInfos',
      tableItem: {
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    }
  ])
  if (type.indexOf('visit') !== -1) {
    columns = columns.concat([
      {
        title: '访问时间',
        name: 'createTime',
        tableItem: {}
      },
      {
        title: '离开时间',
        name: 'quitTime',
        tableItem: {}
      },
      {
        title: '访问终端类型',
        name: 'adapter',
        tableItem: {},
        dict: [
          { code: 0, codeName: 'PC' },
          { code: 1, codeName: 'APP' },
          // {code: 2, codeName: '企业号'},
        ]
      }
    ])
  }
  if (type.indexOf('choose') !== -1) {
    columns = columns.concat([
      {
        title: '选择时间',
        name: 'updateTime',
        tableItem: {}
      },
      {
        title: '状态',
        name: 'status',
        tableItem: {},
        dict: [
          { code: 0, codeName: '无效' },
          { code: 1, codeName: '有效' },
        ]
      }
    ])
  }
  return columns
}
